import React from 'react';
import { SegmentButton, SegmentInput } from './SegmentInput.tsx';

export interface ISegmentInputGroupProps<T extends string | undefined> {
    value: T;
    onChange: (newValue: T) => void;
    options: {label: string, value: T}[];
}

export const SegmentInputGroup = <T extends string | undefined>({ value, onChange, options }: ISegmentInputGroupProps<T>) => {
    return (
        <SegmentInput value={value} onChange={onChange}>
            {options.map(option => (
                <SegmentButton key={option.value} value={option.value}><span style={{ fontSize: 12 }}>{option.label}</span></SegmentButton>
            ))}
        </SegmentInput>
    );
};
